import { useMemo } from 'react';
/**
 * Traverse up to find nearest component
 */
export function useFindNearestComponent(types, component) {
    return useMemo(() => {
        const traverseComponent = (component) => {
            if (typeof types === 'string'
                ? component.type === types
                : types.includes(component.type)) {
                return component;
            }
            else if (component.parent) {
                return traverseComponent(component.parent);
            }
        };
        if (component) {
            return traverseComponent(component);
        }
    }, [component, types]);
}
//# sourceMappingURL=useFindNearestComponent.js.map